import { packLabel } from "../lib/mitti-copy";

/** Same pill as the #aspirant / #teammate tags on a trail. Core is the quieter one. */
const PILL = "inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-medium";
const CORE = `${PILL} bg-paper-200 text-ink-300 dark:bg-clay-floor dark:text-paper-300/70`;
const PACK = `${PILL} bg-paper-100 text-ink-400 dark:bg-clay-raised dark:text-paper-300`;

export default function PackPills({ packs }: { packs: string[] }) {
  return (
    <div className="flex flex-wrap gap-1.5">
      <span className={CORE}>Core</span>
      {packs.map((id) => (
        <span key={id} className={PACK}>
          {packLabel(id)}
        </span>
      ))}
    </div>
  );
}
